import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const mapStateToProps = (state) => {
  return {
    isPrimeOnboardingCompleted:
      state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const DashboardStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default DashboardStore;
